import Vue from 'vue'
import VueCookie from 'vue-cookie'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

Vue.use(Router)
Vue.use(VueCookie)

var route = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: configRoutes()
})

function configRoutes() {
  return [{
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: TheContainer,
      children: [{
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            requireAuth: true
          },
        },
        {
          path: 'heatmap',
          name: 'HeatMap',
          component: () => import('@/views/HeatMap'),
          meta: {
            requireAuth: true
          },
        },
        {
          path: 'faq',
          redirect: '/faq/list',
          name: 'Faq',
          meta: {
            requireAuth: true
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
              path: 'list',
              name: 'Faq List',
              component: () => import('../views/faq/List')
            },
            {
              path: 'add/:id',
              name: 'Faq Add',
              component: () => import('../views/faq/Add')
            },
          ]
        },
        {
          path: 'product',
          redirect: '/product/catalog',
          name: 'Product',
          meta: {
            requireAuth: true
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
              path: 'catalog',
              name: 'Product Katalog',
              component: () => import('../views/product/Catalog')
            },
            {
              path: 'catalog/:id',
              name: 'Product Katalog Add',
              component: () => import('../views/product/CatalogAdd')
            },
          ]
        },
        {
          path: 'product',
          redirect: '/product/catalog-pending',
          name: 'PendingProductCatalog',
          meta: {
            requireAuth: true
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
            path: 'catalog-pending',
            name: 'Pending Katalog',
            component: () => import('../views/product/CatalogPending')
          }, ]
        },
        {
          path: 'outlet',
          redirect: '/outlet',
          name: 'MainOutlet',
          meta: {
            requireAuth: true
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
              path: '',
              name: 'Outlet',
              component: () => import('../views/outlet/List')
            },
            {
              path: ':code',
              name: 'Outlet Detail',
              component: () => import('../views/outlet/Detail')
            },
            {
              path: ':code/prod',
              name: 'Outlet Product',
              component: () => import('../views/outlet/Product')
            },
            {
              path: ':code/transaction',
              name: 'Outlet Transaction',
              component: () => import('../views/outlet/Transaction')
            },
          ]
        },
        {
          path: 'user',
          redirect: '/user',
          name: 'MainUser',
          meta: {
            requireAuth: true
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
            path: '',
            name: 'User',
            component: () => import('../views/user/List')
          }, ]
        },
        {
          path: 'slider',
          redirect: '/slider',
          name: 'MainSlider',
          meta: {
            requireAuth: true
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
              path: '',
              name: 'Slider',
              component: () => import('../views/slide/List')
            },
            {
              path: 'add/:id',
              name: 'Slider Add',
              component: () => import('../views/slide/Add')
            },
          ]
        },
        {
          path: 'product/category',
          redirect: '/product/category',
          name: 'MainCategory',
          meta: {
            requireAuth: true
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
              path: '',
              name: 'Category',
              component: () => import('../views/product/Category')
            },
            {
              path: ':id',
              name: 'Category Add',
              component: () => import('../views/product/CategoryAdd')
            },
          ]
        },
        {
          path: 'product/brand',
          redirect: '/product/brand',
          name: 'MainBrand',
          meta: {
            requireAuth: true
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
              path: '',
              name: 'Brand',
              component: () => import('../views/product/Brand')
            },
            {
              path: ':id',
              name: 'Brand Add',
              component: () => import('../views/product/BrandAdd')
            },
          ]
        },
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/pages/Login')
    }
  ]
}

route.beforeEach((to, from, next) => {
  const authObj = getAuth()
  const now = Math.round((new Date()).getTime() / 1000);

  if (to.matched.some(r => r.meta.requireAuth)) {
    if (authObj == null || parseInt(authObj.expired_at) < now) {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } else {
    next()
  }
});

function getAuth() {
  const auth = Vue.cookie.get("pos.aksestani")
  const authObj = JSON.parse(auth)
  return authObj
}

export default route